export default {
    'methods': {
        validateForm () {
            return this.$validator.validateAll();
        },
        clearValidation () {
            this.validationErrors.clear();
        }
    }
}
;
